const validateEmail = (email: string): boolean => {
  // source https://html.spec.whatwg.org/multipage/input.html#e-mail-state-(type=email)
  return /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/i.test(
    email
  );
};

export default validateEmail;
